(function ($) {
$(document).ready(function () {
            const loading = document.querySelector('.loading');
            const content = document.querySelector('.carousel-content');
            $("#popup-carousel").slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              });
              $(".technologies-slider").on("click", ".slick-slide", function() {
                setTimeout(() => {
                    loading.style.opacity = "0";
                    content.style.opacity = "1";
                    }, 500)
                var initialSlideIndex = $(this).index();
                $(".technologies-carousel-modal").show();
                $("#popup-carousel").slick("slickGoTo", initialSlideIndex);
              });
              $(".technologies-carousel-modal").on("click", ".close", function() {
                $(".technologies-carousel-modal").hide();
                setTimeout(() => {
                    loading.style.opacity = "1";
                    content.style.opacity = "0";
                    }, 100)
              });
            $(".technologies-slider").slick({
                slidesToShow: 2.4,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                autoplay: false,
                customWidth: false,
                variableWidth: true,
                
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                            slidesToShow: 3.2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                    breakpoint: 768,
                    settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                        },
                    },
                    
                ],
            });
            $(".prev-btn").click(function () {
                $(".technologies-slider").slick("slickPrev");
                $("#popup-carousel").slick("slickPrev");
            });

            $(".next-btn").click(function () {
                $(".technologies-slider").slick("slickNext");
                $("#popup-carousel").slick("slickNext");
            });
            $(".prev-btn").addClass("ctrl-disabled");
            $(".technologies-slider").on("afterChange", function () {
                if ($(".slick-prev").hasClass("slick-disabled")) {
                    $(".prev-btn").addClass("ctrl-disabled");
                } else {
                    $(".prev-btn").removeClass("ctrl-disabled");
                }
                if ($(".slick-next").hasClass("slick-disabled")) {
                    $(".next-btn").addClass("ctrl-disabled");
                } else {
                    $(".next-btn").removeClass("ctrl-disabled");
                }
            });
        });
})(jQuery);
